import { resolverIngressoVaga } from "./gestaoVagaIngressoMock.js"

/** Monta linhas da grade com slot de participação (API detalhe + ingresso). */
export function horariosLinhasParticipacao(vaga) {
	const msg = vaga?.mensagem ?? {}
	const ingresso = resolverIngressoVaga(vaga)
	const porDiaId = Object.fromEntries(
		(ingresso.dias || []).map((d) => [d.diaId, d])
	)

	let linhas = []
	if (Array.isArray(msg.horariosLinhas) && msg.horariosLinhas.length > 0) {
		linhas = msg.horariosLinhas
	} else {
		const labels = vaga?.configuracao?.labels ?? {}
		const lblMin = labels.minimo || "Piso mínimo"
		const lblExp = labels.expectativa || "Expectativa de ganho"
		linhas = (Array.isArray(vaga?.horarios) ? vaga.horarios : []).map((h) => {
			const partes = []
			if (h.horaInicio && h.horaFim) {
				partes.push(`${h.horaInicio} – ${h.horaFim}`)
			}
			if (h.valorMinimo) {
				partes.push(`${lblMin}: ${h.valorMinimo}`)
			}
			if (h.expectativaGanho) {
				partes.push(`${lblExp}: ${h.expectativaGanho}`)
			}
			return {
				diaSemana: h.diaSemana,
				diaId: h.diaId,
				diaNome: h.diaNome,
				diaAbrev: h.diaAbrev,
				texto: partes.length > 0 ? partes.join(" · ") : "—",
			}
		})
	}

	return linhas.map((linha) => ({
		...linha,
		slot: linha.slotIngresso ?? porDiaId[linha.diaId] ?? null,
	}))
}

/**
 * Status legível por dia (somente leitura).
 * @returns {{ label: string, variant: 'ok'|'warn'|'brand'|'muted', grupo: string, detalhe?: string }}
 */
export function resolverStatusParticipacaoDia(slot) {
	if (!slot) {
		return {
			label: "Sem vaga neste dia",
			variant: "muted",
			grupo: "outro",
		}
	}
	if (slot.jaInscrito) {
		return {
			label: "Você é titular",
			variant: "ok",
			grupo: "titular",
		}
	}
	if (slot.podeIngressar) {
		return {
			label: "Pode ingressar",
			variant: "brand",
			grupo: "pode_ingressar",
		}
	}
	if (slot.aguardandoJanela || slot.status === "aguardando_janela") {
		return {
			label: "Aguarda abertura",
			variant: "warn",
			grupo: "aguardando",
			detalhe:
				slot.dataInicioIngressoFormatada ||
				slot.dataInicioIngresso ||
				"",
		}
	}
	if (
		slot.aindaNaoAbriuHoje ||
		slot.status === "aguardando_abertura_hoje"
	) {
		return {
			label: "Abre hoje em breve",
			variant: "warn",
			grupo: "aguardando",
			detalhe: slot.mensagemJanelaHoje || "",
		}
	}
	if (
		slot.janelaFilaEncerradaHoje ||
		slot.status === "janela_fila_encerrada_hoje"
	) {
		return {
			label: "Prazo de hoje encerrado",
			variant: "muted",
			grupo: "outro",
			detalhe: slot.mensagemJanelaHoje || "",
		}
	}
	if (slot.status === "conflito_horario" || slot.mensagemConflito) {
		return {
			label: "Conflito de horário",
			variant: "warn",
			grupo: "outro",
			detalhe: slot.mensagemConflito || "",
		}
	}
	const limite = Math.max(1, Number(slot.limitePorDia ?? slot.limiteTitulares) || 1)
	const ocupados = Number(slot.titularesNoDia) || 0
	if (ocupados >= limite) {
		return {
			label: "Dia completo",
			variant: "muted",
			grupo: "outro",
			detalhe: `${ocupados}/${limite} titulares`,
		}
	}
	return {
		label: "Indisponível",
		variant: "muted",
		grupo: "outro",
	}
}

const PESO_GRUPO = { titular: 0, pode_ingressar: 1, aguardando: 2, outro: 3 }

export function ordenarLinhasParticipacao(linhas) {
	return [...linhas].sort((a, b) => {
		const pa = PESO_GRUPO[resolverStatusParticipacaoDia(a.slot).grupo] ?? 9
		const pb = PESO_GRUPO[resolverStatusParticipacaoDia(b.slot).grupo] ?? 9
		if (pa !== pb) return pa - pb
		const da = String(a.slot?.data || a.slot?.dataFormatada || "")
		const db = String(b.slot?.data || b.slot?.dataFormatada || "")
		return da.localeCompare(db)
	})
}

export function resumoParticipacaoVaga(vaga) {
	const linhas = horariosLinhasParticipacao(vaga)
	let titular = 0
	let podeIngressar = 0
	let aguardando = 0
	linhas.forEach((linha) => {
		const g = resolverStatusParticipacaoDia(linha.slot).grupo
		if (g === "titular") titular += 1
		else if (g === "pode_ingressar") podeIngressar += 1
		else if (g === "aguardando") aguardando += 1
	})
	return { titular, podeIngressar, aguardando, total: linhas.length }
}
